import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './theme.css'
// 19-10-2026: telefoonweergave; elke regel staat binnen max-width 899.98px.
import './mobiel.css'
import { loadInstanceConfig } from './lib/instance'
import { installeerPwa } from './lib/pwa'

// De instantie-instellingen moeten er zijn vóór de eerste render, anders
// flitst even de standaard-merknaam voorbij. Ontbreekt config.json, dan
// gelden de standaardwaarden en verandert er niets.
loadInstanceConfig().then((cfg) => {
  // De titel staat in index.html gebakken, en NT en TT delen één build. Wie
  // hem daar laat staan ziet op het TT-dashboard "Nova Temptation" in het
  // tabblad. Vandaar hier, uit config.json.
  document.title = `${cfg.brand} ${cfg.subtitle}`
  // 19-10-2026: beginscherm-app, alleen op de telefoon (lib/pwa).
  installeerPwa(cfg)
}).finally(() => {
  createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
})
